import { BusinessUnitItemSchema } from "@/schemas/business-unit/business-unit-item";
import { z } from "zod";

export const DeploymentBusinessUnitItemSchema = z.object({
  ...BusinessUnitItemSchema.shape,
  ValidationSameProduct: z.boolean().optional(),
});

export type DeploymentBusinessUnitItemType = z.infer<
  typeof DeploymentBusinessUnitItemSchema
>;
